import React from 'react';
import { Badge, Modal } from 'react-bootstrap';
import { NewsletterRecipient } from '../newsletter.types';
import moment from 'moment';
import NoDataFound from 'components/ui/NoDataFound';

interface RecipientPreviewProps {
  recipients: NewsletterRecipient[];
  totalCount: number;
  onClose: () => void;
}

const RecipientPreview: React.FC<RecipientPreviewProps> = ({
  recipients,
  totalCount,
  onClose,
}) => {
  return (
    <Modal show={true} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Recipient Preview ({recipients.length} of {totalCount})
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {recipients.length === 0 ? (
          <NoDataFound />
        ) : (
          <>
            <div className="recipient-list">
              {recipients.map((recipient) => (
                <div
                  key={recipient.user_id}
                  className="recipient-item d-flex align-items-center justify-content-between p-3 mb-2 border rounded"
                >
                  <div>
                    <div className="fw-600">
                      {recipient.first_name} {recipient.last_name}
                    </div>
                    <div className="text-muted small">{recipient.email}</div>
                    {recipient.last_login && (
                      <div className="text-muted small">
                        Last login: {moment(recipient.last_login).fromNow()}
                      </div>
                    )}
                  </div>
                  <Badge
                    bg={
                      recipient.user_type === 'client' ? 'primary' : 'success'
                    }
                  >
                    {recipient.user_type === 'client' ? 'Client' : 'Freelancer'}
                  </Badge>
                </div>
              ))}
            </div>

            {recipients.length < totalCount && (
              <div className="text-center mt-3 py-3 bg-light rounded">
                <p className="mb-0 text-muted">
                  Showing first {recipients.length} recipients out of{' '}
                  {totalCount} total
                </p>
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RecipientPreview;
